import {
  GET_CARGO_TYPE_LIST,
  GET_CARGO_TYPE_LIST_SUCCESS,
  GET_CARGO_TYPE_LIST_FAIL,
  GET_SINGLE_CARGO_TYPE,
  GET_SINGLE_CARGO_TYPE_SUCCESS,
  GET_SINGLE_CARGO_TYPE_FAIL,
  DELETE_CARGO_TYPE_REQUEST,
  DELETE_CARGO_TYPE_SUCCESS,
  DELETE_CARGO_TYPE_FAIL,
  ADD_CARGO_TYPE_REQUEST,
  ADD_CARGO_TYPE_SUCCESS,
  ADD_CARGO_TYPE_FAIL,
  UPDATE_CARGO_TYPE_REQUEST,
  UPDATE_CARGO_TYPE_SUCCESS,
  UPDATE_CARGO_TYPE_FAIL,
} from "src/constants/types";

export const cargoTypeReducers = (state = {}, actions) => {
  switch (actions.type) {
    case GET_CARGO_TYPE_LIST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_CARGO_TYPE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        cargoTypeList: actions.payload,
        error: "",
      };
    case GET_CARGO_TYPE_LIST_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case GET_SINGLE_CARGO_TYPE:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_SINGLE_CARGO_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        cargoType: actions.payload,
      };
    case GET_SINGLE_CARGO_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case DELETE_CARGO_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case DELETE_CARGO_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case DELETE_CARGO_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case ADD_CARGO_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case ADD_CARGO_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: "",
      };
    case ADD_CARGO_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    case UPDATE_CARGO_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case UPDATE_CARGO_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case UPDATE_CARGO_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
